import { Button } from "primereact/button";
import { InputMask } from "primereact/inputmask";
import { InputTextarea } from "primereact/inputtextarea";
import { SelectButton } from "primereact/selectbutton";
import { useState } from "react";
import {
  adicionarAnaliseDevolutivaAcao,
  updatedAnaliseDevolutivoProgramaIndicador,
  adicionarAnaliseDevolutivaProgramaIndicador,
} from "../../../../../../service/Rag/lançamento/acao";
import ModalSeplag from "../../../../../../components/ModalSeplag";
import RotuloSeplag from "../../../../../../components/RotuloSeplag";
import { Dropdown } from "primereact/dropdown";
import { printToast } from "../../../../../../config/global";

const ModalDevolutivaProgramaIndicadorSeplag2024 = ({
  visibleModaldevolutiva,
  setVisibleModalDevolutiva,
  setActionModal,
  actionModal,
  setAtualizarData,
  dataRow,
  dadosItemPrograma,
  _dataRowOrgaoCentral,
  infoUnidade,
}) => {
  //console.log("ChegouModalDataRow",dataRow," acao",actionModal)
  //console.log("ChegouModalDevolucao_dataRowOrgaoCentral",_dataRowOrgaoCentral)  

  const [data, setData] = useState({
    dataAnaliseIndicador: actionModal.create ? "" : (dataRow.dataAnaliseIndicador !== undefined ? dataRow.dataAnaliseIndicador : ""),    
    descAnaliseIndicador: actionModal.create ? "" : (dataRow.descAnaliseIndicador !== undefined ? dataRow.descAnaliseIndicador : ""),
    maximoCaracteres: 4000,
    numrAnaliseRecomendacao: actionModal.create ? "" : (dataRow.numrAnaliseRecomendacao !== undefined ? dataRow.numrAnaliseRecomendacao : null),
  });

  const getRecomendacaoDescription = (code) => {
    const found = analiseRecomendacaoAcaoOptions.find((item) => item.code === code);
    return found ? found.name : code;
  };
  
  const analiseRecomendacaoAcaoOptions = [
    { name: "Baixo Impacto", code: 0 },
    { name: "Médio Impacto", code: 1 },
    { name: "Alto Impacto", code: 2 },
  ]; 

  const respostaSetorialAcaoOptions = [
    { name: "Não acatado", code: 0 },
    { name: "Acatado", code: 1 },
    { name: "Parcialmente acatado", code: 2 },
  ];

  const isValidDate = (dateString) => {
    const [day, month, year] = dateString.split("/").map(Number);
    const date = new Date(year, month - 1, day);

    // Verifica se a data informada é válida
    const isCorrectDate = date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
    if (!isCorrectDate) return false;

    // Compara com a data atual
    const currentDate = new Date();
    return date <= currentDate;
  };
  
  const salvarAnaliseDevolutivo = async () => {
    let now = new Date();
    let date = now.getDate() + "/" + (now.getMonth() + 1) + "/" + now.getFullYear();
    let formAnaliseDevolutivoPrograma = {
      ...dataRow,      
      idenDevolutiva: _dataRowOrgaoCentral.idenAnaliseIndicador,
      indicador: { idenIndicador: _dataRowOrgaoCentral.indicador.idenIndicador },
      dataInclusao: date,
      idenPrograma: dadosItemPrograma.dadosItemRag.idenPrograma,
    };

    let classificacao = getRecomendacaoDescription(_dataRowOrgaoCentral.numrAnaliseRecomendacao)

    formAnaliseDevolutivoPrograma.idenAnaliseIndicador = dataRow.idenAnaliseIndicador;
    formAnaliseDevolutivoPrograma.dataAnaliseIndicador = data.dataAnaliseIndicador;
    formAnaliseDevolutivoPrograma.descAnaliseIndicador = data.descAnaliseIndicador;
    formAnaliseDevolutivoPrograma.numrAnaliseRecomendacao = data.numrAnaliseRecomendacao;
    formAnaliseDevolutivoPrograma.statAnaliseIndicador = 1;
    formAnaliseDevolutivoPrograma.tipoAnaliseIndicador = 2;

    //debugger
    //console.log("DadosIndicador:", _dataRowOrgaoCentral.indicador)
    
    let descEmail = `Processo RAG ${_dataRowOrgaoCentral.indicador.exercicio.ano}: foi inserida uma recomendação no item: ${infoUnidade.descricaoFiplan}
                    , Programa: ${dadosItemPrograma.dadosItemRag.codgPrograma} - ${dadosItemPrograma.dadosItemRag.descPrograma}    
                    , Indicador: ${_dataRowOrgaoCentral.indicador.codgIndicador} - ${_dataRowOrgaoCentral.indicador.descIndicador}                             
                    , Classificação: ${classificacao} `;

    //let descEmail = " " //AQUI provisorio
    //console.log("emailDevolutivaIndicador:",descEmail)    
    
    if (data.numrAnaliseRecomendacao === null || data.numrAnaliseRecomendacao === "") {
      return printToast({ severity: "error", detail: "Resposta da setorial deve ser informado" });
    }

    if (formAnaliseDevolutivoPrograma.descAnaliseIndicador.trim() === "") {
      return printToast({ severity: "error", detail: "Informe uma descrição para sua devolutiva" });
    }

    if (!isValidDate(formAnaliseDevolutivoPrograma.dataAnaliseIndicador)) {
      return printToast({ severity: "error", detail: "A data da devolutiva deve ser menor ou igual à data atual" });
    }

    await adicionarAnaliseDevolutivaProgramaIndicador({
      analiseIndicador: { ...formAnaliseDevolutivoPrograma },
      descEmail: descEmail,
    }).then((_res) => {
      window.$toast.current.show({
        severity: "success",
        summary: "Devolução Criada",
        detail: "Criado com Sucesso",
        life: 5000,
      });
      setAtualizarData(true);
      setVisibleModalDevolutiva(false);
    });
  };

  const alterarAnalDevolutivo = async () => {
    let formAnaliseDevolutivoPrograma = { ...dataRow,  //Copia todos os valores      
      idenDevolutiva: dataRow.idenDevolutiva,      
      indicador: { idenIndicador: dataRow.indicador.idenIndicador },
     };
    
    formAnaliseDevolutivoPrograma.idenAnaliseIndicador = dataRow.idenAnaliseIndicador
    formAnaliseDevolutivoPrograma.dataAnaliseIndicador = data.dataAnaliseIndicador;
    formAnaliseDevolutivoPrograma.descAnaliseIndicador = data.descAnaliseIndicador;    
    formAnaliseDevolutivoPrograma.numrAnaliseRecomendacao = data.numrAnaliseRecomendacao;      

    await updatedAnaliseDevolutivoProgramaIndicador({
      idenAnaliseIndicador: dataRow.idenAnaliseIndicador,
      postBody: formAnaliseDevolutivoPrograma,
    }).then((_res) => {
      window.$toast.current.show({
        severity: "success",
        summary: "Devolução Alterada",
        detail: "Alterado com Sucesso",
        life: 5000,
      });
      setAtualizarData(true);
      setVisibleModalDevolutiva(false);
    });
  };

  return (
    <ModalSeplag
      titulo="Devolutiva da equipe da Unidade Setorial"
      tamanho="960px"
      type="NONE"
      visible={visibleModaldevolutiva}
      fechar={() => {
        setVisibleModalDevolutiva(false);
      }}
    >
      <div className="p-fluid grid line-height-6">
        <div className="field col-12 md:col-12 ">
          <div className="p-fluid grid line-height-4">
            <div className="field col-12 md:col-6 ">
              <RotuloSeplag nome="Data">
                <InputMask
                  mask="99/99/9999"
                  disabled={actionModal.disabled}
                  placeholder="__/__/____"
                  value={data.dataAnaliseIndicador}
                  onChange={(e) => {
                    setData((prevState) => ({
                      ...prevState,
                      dataAnaliseIndicador: e.value,
                    }));
                  }}
                  className="p-inputtext-lg"
                ></InputMask>
              </RotuloSeplag>
            </div>
            <div className="field col-12 md:col-6">
              <RotuloSeplag nome="Resposta da Setorial" cols="3">
                <Dropdown
                  id="rowId"
                  emptyMessage="Dados não encontrados"
                  options={respostaSetorialAcaoOptions}
                  value={data.numrAnaliseRecomendacao}
                  onChange={(e) => {
                    setData((prevState) => ({ ...prevState, numrAnaliseRecomendacao: e.value }));
                  }}
                  optionLabel="name"
                  optionValue="code"
                  placeholder="Selecione um item"
                  disabled={actionModal.disabled}
                />
              </RotuloSeplag>
            </div>

            <div className="field col-12 md:col-12">
              <RotuloSeplag nome="Devolutiva da Unidade Setorial quanto ao item selecionado." cols="3">
                <InputTextarea
                  autoResize
                  maxLength={data.maximoCaracteres}
                  disabled={actionModal.disabled}
                  value={data.descAnaliseIndicador}
                  onChange={(e) => {
                    setData((prevState) => ({
                      ...prevState,
                      descAnaliseIndicador: e.target.value,
                    }));
                  }}
                />
                <span>
                  {data.descAnaliseIndicador === ""
                    ? `${data.maximoCaracteres} caracteres Restante`
                    : ` ${data.maximoCaracteres - data.descAnaliseIndicador.length} caracteres restantes `}
                </span>
              </RotuloSeplag>
            </div>
          </div>
          <div className="grid" style={{ margin: "1rem" }}>
            {actionModal.edit === true && (
              <div className="col">
                <Button label="Alterar" onClick={alterarAnalDevolutivo} />
              </div>
            )}

            <div className="col">
              <Button
                label={actionModal.disabled === true ? "Fechar" : "Cancelar"}
                className="p-button-secondary"
                onClick={() => {
                  setVisibleModalDevolutiva(false);
                  setActionModal({
                    edit: false,
                    disbled: false,
                    create: false,
                  });
                }}
              />
            </div>
            {actionModal.create === true && (
              <div className="col">
                <Button label="Adicionar" onClick={salvarAnaliseDevolutivo} />
              </div>
            )}
          </div>
        </div>
      </div>
    </ModalSeplag>
  );
};
export default ModalDevolutivaProgramaIndicadorSeplag2024;
